<template>
  <simple-scrollable-modal class="order-created-modal">
    <template #title>
      <span>Pedido creado</span>
    </template>
    <template #content>
      <v-row>
        <v-col cols="12">
          <p>El pedido es el número</p>
          <div class="order-number">#{{ order.humanId }}</div>
        </v-col>
      </v-row>
    </template>
    <template #action-bar>
      <div class="d-flex flex-row align-center justify-space-between">
        <div class="flex-fill text-right">
          <v-btn color="info" depressed @click="close"> Cerrar </v-btn>
        </div>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import SimpleScrollableModal from '../base/SimpleScrollableModal.vue';
  import { IOrder } from '../../../interfaces/IOrder';
  @Component({
    components: { SimpleScrollableModal },
  })
  export default class OrderCreatedModal extends Vue {
    @Prop() order: IOrder;

    async created() {}

    close() {
      this.$emit('close');
    }
  }
</script>
